import React, { useCallback, useEffect, useRef } from "react"
import AvailableToLink from "../components/DMAutomation/AvailableToLink"
import { useSelector } from "react-redux"
import { AppDispatch, RootState } from "../redux-stores/store"
import { useDispatch } from "react-redux"
import { fetchDMAutomations, setSelectedSocialAccount } from "../redux-stores/slices/dmAutomationsListSlice"
import { INIT_IG_AUTH_ROUTE, TAGLINKS_DEMO_VIDEO_URL, TAGLINKS_ROCKET_IMG } from "../constants/constants"
import AllLinkedPosts from "../components/DMAutomation/AllLinkedPosts"
import { Link } from "react-router-dom"
import AccountSelector from "../components/account/AccountSelector"
import IGAccountSelector from "../components/account/IGAccountSelector"

const DMAutomations: React.FC = () => {

    const videoRef = useRef<HTMLVideoElement>(null);


    const selectedSocialAccount = useSelector((state: RootState) => state.dmAutomationsList.selectedSocialAccount);
    const connectionRequired = !selectedSocialAccount || selectedSocialAccount.status !== 'connected';

    const igSocialAccounts = useSelector((state: RootState) => state.influencer.social_accounts?.filter(account => account.social_account.platform === 'ig'));

    const dispatch = useDispatch<AppDispatch>();

    const dmAutomationsData = useSelector((state: RootState) => state.dmAutomationsList.automations[selectedSocialAccount?.social_account?.uuid!])
    const dmAutomations = dmAutomationsData?.items || [];
    const cta_url = dmAutomationsData?.cta_url || null;

    const loading = useSelector((state: RootState) => state.dmAutomationsList.automations[selectedSocialAccount?.social_account?.uuid!]?.loading);

    const fetchAutomations = useCallback(async (pageNumber: number, force = false) => {
        if(!selectedSocialAccount) return;
        dispatch(fetchDMAutomations({ socialAccountId: selectedSocialAccount?.social_account?.uuid!, page: pageNumber, force }))
    }, [dispatch, selectedSocialAccount])


    useEffect(() => {
        fetchAutomations(1);
    }, [fetchAutomations, selectedSocialAccount])

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.play().catch(err => console.log("Autoplay failed:", err));
        }
    }, []);

    useEffect(() => {
        if(!selectedSocialAccount && igSocialAccounts.length > 0){
            dispatch(setSelectedSocialAccount(igSocialAccounts[0]));
        }
    }, [selectedSocialAccount, igSocialAccounts])

    return (
        <React.Fragment>
            <React.Fragment>
                <div className="card card-style min-h-500">
                    <div className="card-body text-center py-4">
                        <h1 className="pop px-5">Send DMs Fast and Grow Your Affiliate Marketing!</h1>
                        <video ref={videoRef} src={TAGLINKS_DEMO_VIDEO_URL} muted={true} autoPlay={true} playsInline={true} loop={true} preload="auto"
                            className="w-100"></video>
                    </div>
                </div>
                {
                    cta_url &&
                    <div className="card card-style">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-column px-2">
                                    <h4>See how this feature works</h4>
                                    <span>Checkout our instagram post and comment “wow” to explore this incredible feature!</span>
                                    <a href={cta_url} target="_blank" rel='noreferrer' className="btn btn-primary btn-sm w-100 rounded-4 mt-3">Go to Instagram</a>
                                </div>
                                <div className="img">
                                    <img src={TAGLINKS_ROCKET_IMG} height={200} className="rounded-sm object-fit-contain" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
            <div className="d-flex align-items-center justify-content-between m-3">
                <h6>Smart Links</h6>
                <IGAccountSelector socialAccount={selectedSocialAccount} socialAccounts={igSocialAccounts} onChange={(account) => dispatch(setSelectedSocialAccount(account))} />
            </div>
            {
                !loading && !connectionRequired && 
                <React.Fragment>
                    <AvailableToLink />
                    <AllLinkedPosts dmAutomations={dmAutomations} />
                </React.Fragment>
            }
            {
                !loading && connectionRequired && 
                <div className="card card-style">
                    <div className="card-body">
                        <div className="px-2">
                        <h3 className="pop">
                            Connect with Instagram to use Smart Links
                        </h3>
                        <p>To start using Smart Links, please connect with your Instagram account first.</p>
                        <Link to={`${INIT_IG_AUTH_ROUTE}?feature=dm-automation`} className="btn btn-sm btn-primary rounded-4">Connect with Instagram</Link>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default DMAutomations